import type { PlatformToastAction, PlatformToastResourceContext, PlatformToastResourceType } from './types';

type ResourcePathBuilder = (resource: PlatformToastResourceContext) => string | undefined;

const resourcePathBuilders: Record<PlatformToastResourceType, ResourcePathBuilder> = {
    dashboard: ({ id }) => `/dashboards/${encodeURIComponent(id)}`,
    folder: ({ id }) => `/folders/${encodeURIComponent(id)}`,
    investment: ({ id }) => `/investments/${encodeURIComponent(id)}`,
    list: ({ id }) => `/lists/${encodeURIComponent(id)}`,
    'list-view': ({ id, parentId }) =>
        parentId ? `/lists/${encodeURIComponent(parentId)}?view=${encodeURIComponent(id)}` : undefined,
    memo: ({ id }) => `/memos/${encodeURIComponent(id)}`,
    note: ({ id }) => `/relations/notes?note=${encodeURIComponent(id)}`,
    pipeline: ({ id }) => `/pipelines/${encodeURIComponent(id)}`,
    report: ({ id, parentId }) =>
        parentId ? `/dashboards/${encodeURIComponent(parentId)}?report=${encodeURIComponent(id)}` : undefined,
    task: ({ id }) => `/relations/tasks?task=${encodeURIComponent(id)}`,
    team: ({ id }) => `/settings/workspace/permissions/teams/${encodeURIComponent(id)}`,
};

export const getPlatformToastResourceHref = (resource: PlatformToastResourceContext): string | undefined =>
    resource.href ?? resourcePathBuilders[resource.type](resource);

export const createPlatformToastResourceAction = (
    resource: PlatformToastResourceContext,
): PlatformToastAction | undefined => {
    const href = getPlatformToastResourceHref(resource);

    if (!href) {
        return undefined;
    }

    return {
        ariaLabel: typeof resource.actionLabel === 'string' ? resource.actionLabel : 'View resource',
        href,
        label: resource.actionLabel ?? 'View Resource',
    };
};
